import ApiService from "./ApiService";


const ApiService2 = {
  fetchData(param) {
    return ApiService.fetchData({
      ...param,
      skipGlobalSuccessToast: true,
      rawError: true,
    });
  },
};

export default ApiService2;
